export const ACTIVITY_LOG_ENDPOINTS = {
  LIST: "/activity-log/activity-log-list",
  USERS: "/users/getAllUsers",
};
